import React from 'react';
import { Wallet, Coins, Cpu } from 'lucide-react';

const BottomNav = ({ setSelectedTab }) => {
  return (
    <nav className="md:hidden fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-[#1a1a1a] rounded-2xl shadow-xl border border-[#2c2c2c] px-4 py-2 z-50 backdrop-blur-md">
      <div className="flex items-center justify-center gap-x-4 text-gray-400">
        {/* Wallet */}
        <button
          onClick={() => setSelectedTab('wallet')}
          className="flex flex-col items-center justify-center px-2 py-1 hover:text-indigo-400 transition-all"
        >
          <Wallet size={22} />
          <span className="text-xs mt-1">Wallet</span>
        </button>

        {/* Staking */}
        <button
          onClick={() => setSelectedTab('staking')}
          className="flex flex-col items-center justify-center px-2 py-1 hover:text-indigo-400 transition-all"
        >
          <Coins size={22} />
          <span className="text-xs mt-1">Staking</span>
        </button>

        {/* Mining */}
        <button
          onClick={() => setSelectedTab('mining')}
          className="flex flex-col items-center justify-center px-2 py-1 hover:text-indigo-400 transition-all"
        >
          <Cpu size={22} />
          <span className="text-xs mt-1">Mining</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav;
